import { ComponentChild, VNode, JSX } from 'preact';

import { Typography } from '../Typography/Typography';
import { Unpacked } from '../../utils/types';
import { useIcons } from '../../hooks/useIcons';
import { IconButton } from '../IconButton/IconButton';

export interface ListProps<T> {
  value: T;
  options: {
    label: ComponentChild;
    value: T;
  }[];
  onSelectedValueChange: (value: T) => void;
}

export const List = <T extends string | number>({
  value,
  options,
  onSelectedValueChange,
}: ListProps<T>): VNode | null => {
  const { Check } = useIcons();
  const handleKeyDown =
    (
      option: Unpacked<typeof options>
    ): JSX.KeyboardEventHandler<HTMLLIElement> =>
    (e) => {
      if (e.code === 'Enter' || e.code === 'Space') {
        onSelectedValueChange(option.value);
      }
    };

  return (
    <ul className="vgp-list">
      {options.map((option) => {
        const isSelected = option.value === value;

        return (
          <li
            role="option"
            tabIndex={0}
            key={option.value}
            className="vgp-list-item"
            aria-selected={isSelected}
            onClick={() => onSelectedValueChange(option.value)}
            onKeyDown={handleKeyDown(option)}
          >
            <Typography
              variant="label"
              size="medium"
              color="primary"
              bold={isSelected}
            >
              {option.label}
            </Typography>
            {isSelected && (
              <IconButton color="transparent-primary">
                <Check />
              </IconButton>
            )}
          </li>
        );
      })}
    </ul>
  );
};
